import apiSlice from "../apiSlice";


const productsApiSlice = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        deliveryPrices: build.query({
            query: () => (`/delivery/prices/`)
        }),
        cities: build.query({
            query: () => (`/delivery/cities/`)
        })
    })
})


export const { useDeliveryPricesQuery, useCitiesQuery } = productsApiSlice;